import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAllRiskAssessmentCategories(context) {
    return axios
      .get("riskAssessmentCategory")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  createRiskAssessmentCategory(context, value) {
    return axios
      .post("riskAssessmentCategory", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.createdMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteRiskAssessmentCategory(context, val) {
    return axios
      .delete("riskAssessmentCategory/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.deletedMessage"),
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateRiskAssessmentCategory(context, value) {
    return axios
      .put("riskAssessmentCategory/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.updatedMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleRiskAssessmentCategory(context, id) {
    return axios
      .get("riskAssessmentCategory/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getRiskAssessmentCategoryCounts(context) {
    return axios
      .get("riskAssessmentCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
